import { EnumResolver } from '../../../../commons/enums/enum-resolver.js';

// @lib-export
var ApplicationAccessPolicyVo;
(function (ApplicationAccessPolicyVo) {
    ApplicationAccessPolicyVo["ANONYMOUS_AND_LOGIN"] = "ANONYMOUS_AND_LOGIN";
    ApplicationAccessPolicyVo["LOGGED_IN_CUSTOMER_MANAGERS"] = "LOGGED_IN_CUSTOMER_MANAGERS";
    ApplicationAccessPolicyVo["LOGIN"] = "LOGIN";
    ApplicationAccessPolicyVo["SELECT_CUSTOMER_OR_ORGS"] = "SELECT_CUSTOMER_OR_ORGS";
})(ApplicationAccessPolicyVo || (ApplicationAccessPolicyVo = {}));
const APPLICATION_ACCESS_POLICY_VO_RESOLVER = new EnumResolver(`ApplicationAccessPolicyVo`, Object.entries(ApplicationAccessPolicyVo));

export { APPLICATION_ACCESS_POLICY_VO_RESOLVER, ApplicationAccessPolicyVo };
//# sourceMappingURL=application-access-policy-vo.js.map
